import styles from '../MontlyRevenue.module.scss'

const RadioGroup = ({ value, onChange, options, label }) => {
  return (
    <div>
      <p className={styles.radioGroupLabel}>{label}</p>
      <div className={styles.radioGroup}>
        {Object.keys(options).map(key => (
          <label key={key} className={styles.radioGroupItem}>
            <input
              type="radio"
              name="kind"
              value={key}
              checked={value === key}
              onChange={() => onChange(key)}
            />
            <span>{options[key]}</span>
          </label>
        ))}
      </div>
    </div>
  )
}

export default RadioGroup
